import { Box } from "@mui/material";
import React from "react";
import EditableTable from "components/Table/EditableTable";
import dayjs from "dayjs";

export default function AdminTable({ data, loadingState }) {
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "startTime",
      headerName: "Start time",
      width: 200,
      valueGetter: (params) =>
        // Return the formatted date
        dayjs(params.value).format("YYYY-MM-DD hh:mm A"),
    },
    {
      field: "created_at",
      headerName: "Completion Time",
      width: 200,
      valueGetter: (params) =>
        // Return the formatted date
        dayjs(params.value).format("YYYY-MM-DD hh:mm A"),
    },
    { field: "submitterEmail", headerName: "Email / Contact No.", width: 200 },
    { field: "consent", headerName: "Consent", width: 150 },
    { field: "submittername", headerName: "Name", width: 150 },
    { field: "specificAge", headerName: "Age", width: 100 },
    { field: "relatedClientType", headerName: "Customer Type", width: 200 },
    { field: "officeName", headerName: "Office Transacted", width: 500 },
    { field: "serviceKindDescription", headerName: "Service Type", width: 100 },
    { field: "serviceDesc", headerName: "Service Availed", width: 300 },
    { field: "otherService", headerName: "Other Service", width: 150 },
    { field: "responsiveness", headerName: "Responsiveness", width: 150 },
    { field: "reliability", headerName: "Reliability", width: 100 },
    {
      field: "accessAndFacilities",
      headerName: "Access and Facilities",
      width: 150,
    },
    { field: "communication", headerName: "Communication", width: 120 },
    { field: "costs", headerName: "Costs", width: 120 },
    { field: "integrity", headerName: "Integrity", width: 90 },
    { field: "assurance", headerName: "Assurance", width: 100 },
    { field: "outcome", headerName: "Outcome", width: 100 },
    { field: "averageRating", headerName: "Average Rating", width: 120 },
    {
      field: "overallComment",
      headerName: "Overall Comment/Suggestions",
      width: 300,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <EditableTable
        data={data}
        columns={columns}
        loading={loadingState}
        height="60vh"
        showSearch
      />
    </Box>
  );
}
